import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../utils/tracking';
import { PRODUCT_LINKS, variantIdOf } from '../data/productLinks';

/**
 * The pixel snippet fires PageView once when the site first loads. Moving between
 * pages inside the site (/guide, /track, /legal/...) doesn't reload the browser,
 * so this fires PageView on each of those page changes, plus ViewContent once
 * per visit to the sales page.
 */
export function PixelRouteTracker() {
  const {
    pathname
  } = useLocation();
  const firstLoad = useRef(true);
  const viewedProduct = useRef(false);
  useEffect(() => {
    if (firstLoad.current) {
      firstLoad.current = false;
    } else {
      trackEvent('PageView');
    }
    if (pathname === '/' && !viewedProduct.current) {
      viewedProduct.current = true;
      trackEvent('ViewContent', {
        content_name: 'GritVue X1',
        content_ids: [variantIdOf(PRODUCT_LINKS.singleX1)],
        content_type: 'product',
        value: 49.95,
        currency: 'USD'
      });
    }
  }, [pathname]);
  return null;
}